import { render } from "./LoadingPage.vue?vue&type=template&id=2def445d&scoped=true&ts=true"
import script from "./LoadingPage.vue?vue&type=script&lang=ts"
export * from "./LoadingPage.vue?vue&type=script&lang=ts"

import "./LoadingPage.vue?vue&type=style&index=0&id=2def445d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2def445d"]])

export default __exports__